/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {NgxSpinnerService} from 'ngx-spinner';
import { LicenseType } from '../../model/license-type';
import { LicenseTypeService } from '../../services/license-type.service';
import {BaseMessageComponent} from '../../common/base-message.component';

@Component({
    selector: 'app-license-types',
    templateUrl: './license-types.component.html',
    standalone: false
})
export class LicenseTypesComponent extends BaseMessageComponent implements OnInit {
  licenseTypes: LicenseType[];
  indexWithChanges: number[] = [];

  constructor(private licenseTypeService: LicenseTypeService,
              private spinnerService: NgxSpinnerService,
              cdr: ChangeDetectorRef) {
    super(cdr);
  }

  ngOnInit() {
    this.getLicenseTypes();
  }

  getLicenseTypes(): void {
    this.spinnerService.show();
    this.licenseTypes = [];
    this.indexWithChanges = [];
    this.licenseTypeService.getAll().subscribe( value => {
      this.licenseTypes = value;
      this.cdr.detectChanges();
      },
      err => {
      console.log(err);
      alert(err);
        this.spinnerService.hide();
      },
      () => {
        this.spinnerService.hide();
    }
    );
  }

  addNew(name: string) {
    if (name.trim() == "") {
      alert("Please add a license type before saving a new record.");
    } else {
      this.spinnerService.show();
      var licenseType = new LicenseType();
      licenseType.licenseType = name;

      this.licenseTypeService.addNew(licenseType).subscribe(value => {
          //success
          this.licenseTypes = null;
          this.getLicenseTypes();
        }, (error) => {
          //failed
          console.error(error);
          if (error.status=='409')
            alert("Duplicate Value(s) found.");
          else
            alert(error.message);
          this.spinnerService.hide();
        },
        () => {
          this.spinnerService.hide();
        });
    }
  }

  updateLicenseTypeIndexes(index) {
    if(this.indexWithChanges.indexOf(index)===-1){
      this.indexWithChanges.push(index);
    }
    console.log(this.indexWithChanges);
  }

  saveChanges() {
    if(this.indexWithChanges.length > 0) {
      for (var i = 0; i < this.indexWithChanges.length; i++) {
        var idx = this.indexWithChanges[i];
        this.licenseTypeService.update(this.licenseTypes[idx]).subscribe(value => {
            console.log(this.licenseTypes[idx] + " saved.")
          }, (error) => {
            //failed
            console.error(error);
            if (error.status=='409')
              alert("Duplicate Value(s) found.");
            else
              alert(error.message);
          },
          () => {
            this.indexWithChanges = [];
          });
      }
      setTimeout(() => {
        this.getLicenseTypes();
      }, 4000);
    } else {
      alert("No changes to save.");
    }
  }
}
